
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/home",
      function () {
        return require("private-next-pages/[locale]/home/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/home"])
      });
    }
  